import { CdekOffice } from '@shared/types/cdek';
import FetchData from '@shared/utils/fetchData/fetchData';

export const getCdekDeliveryPoints = async (code: number) => {
  const res = await FetchData.get<{ deliveryPoints: CdekOffice[] }>(`v2/delivery/deliverypoints?city_code=${code}`, {});

  return res.data?.deliveryPoints ?? [];
};
